import { render, staticRenderFns } from "./SaleSurveyModal.vue?vue&type=template&id=4795370c&"
import script from "./SaleSurveyModal.vue?vue&type=script&lang=js&"
export * from "./SaleSurveyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports